import React, { useState } from 'react';
import Agenda from './Agenda';
import General from './General';
import Notifications from './Notifications';
import Profile from './Profile';
import RowColLayout from '../../components/RowColLayout';
import LiquidContainer from '../../components/LiquidContainer';
import CardDetails from '../../components/CardDetails';
import Header from '../../components/Header';
import FooterLanding from '../../components/FooterLanding';


const MainLanding = ({children}) => {
  // State to manage the active page
  const [activePage, setActivePage] = useState('general');
  const [selectedSection, setSelectedSection] = useState(null);

  return (
      <div className="mainlanding vh-100 d-flex flex-column position-relative overflow-y-scroll"
        style={{
        backgroundImage: "url('/static/images/backLogin.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
        <Header />

        {/* children content */}
        <div className='flex-grow-1 d-flex flex-column justify-content-center align-items-center'>
          {children}
        </div>

        <FooterLanding />
      </ div>
  );
};

export default MainLanding;
